import { SimpleGrid, SimpleGridProps } from '@mantine/core';

export type ISimpleGridProps = SimpleGridProps;

export function ZorroSimpleGrid({ ...props }: ISimpleGridProps) {
  return <SimpleGrid {...props} />;
}
